import { createContext, useContext, useEffect, useState, useCallback } from "react";

const THEMES = [
  { id: "dark",          name: "Professional Dark",  swatch: "#16181D" },
  { id: "light",         name: "Professional Light", swatch: "#FAFAFA" },
  { id: "midnight",      name: "Midnight",           swatch: "#05060A" },
  { id: "trading",       name: "Trading Floor",      swatch: "#0A0F0D" },
  { id: "ocean",         name: "Ocean",              swatch: "#051524" },
  { id: "emerald",       name: "Emerald",            swatch: "#05130E" },
  { id: "high-contrast", name: "High Contrast",      swatch: "#000000" },
];

const DENSITY_OPTIONS = [
  { id: "compact",   label: "Compact",   scale: 0.94 },
  { id: "normal",    label: "Normal",    scale: 1.00 },
  { id: "spacious",  label: "Spacious",  scale: 1.10 },
];

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("sth.theme") || "dark");
  const [density, setDensity] = useState(() => localStorage.getItem("sth.density") || "normal");
  const [fontScale, setFontScale] = useState(() => parseFloat(localStorage.getItem("sth.fontScale") || "1"));

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("sth.theme", theme);
  }, [theme]);
  useEffect(() => {
    const d = DENSITY_OPTIONS.find(x => x.id === density) || DENSITY_OPTIONS[1];
    document.documentElement.style.setProperty("--font-scale", String(fontScale * d.scale));
    localStorage.setItem("sth.density", density);
    localStorage.setItem("sth.fontScale", String(fontScale));
  }, [density, fontScale]);

  const cycleTheme = useCallback(() => {
    const idx = THEMES.findIndex(t => t.id === theme);
    setTheme(THEMES[(idx + 1) % THEMES.length].id);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, cycleTheme, themes: THEMES, density, setDensity, densities: DENSITY_OPTIONS, fontScale, setFontScale }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);

/* Small palette button for Layout header + Settings page */
export function ThemeSwitcher() {
  const t = useTheme();
  if (!t) return null;
  return (
    <div className="flex items-center gap-1" data-testid="theme-switcher">
      {t.themes.map(x => (
        <button
          key={x.id}
          data-testid={`theme-${x.id}`}
          onClick={() => t.setTheme(x.id)}
          title={x.name}
          aria-label={x.name}
          className="w-5 h-5 rounded-full border-2 transition-transform hover:scale-110"
          style={{
            backgroundColor: x.swatch,
            borderColor: t.theme === x.id ? "var(--gold)" : "var(--border-default)",
          }}
        />
      ))}
    </div>
  );
}
